/* ============================================================
   DIOSA — Body Moldeador con Tiras (slug 'diosa').

   Producto Shopify "BODY CON TIRAS/2680" (8633723650209) con 36 variantes
   REALES Color x Talla, mapeadas 1:1 con Dropi. Por eso los combos
   (1/2/3 unidades) NO son variantes: son la MISMA variante color+talla con
   quantity N + descuentos automáticos de Shopify que ajustan el total:
     1 unidad  -> qty 1 = $79.900
     2 unidades-> qty 2 = $159.800 - $9.900  = $149.900
     3 unidades-> qty 3 = $239.700 - $39.800 = $199.900
   El pedido llega a Dropi como "Color/Talla x N" (despacha N unidades).
   Requiere quantityControlsHidden:true en Releasit (ya global) para que el
   cliente no pueda cambiar la cantidad y desarmar el precio.

   El match de variante es por (color, talla) — NUNCA por SKU, porque Dropi
   re-SKUea al reimportar. Ver memory/project_northpower_landing y
   memory/feedback_dropi_resku_variant_match.
   ============================================================ */
(function () {
  var root = document.querySelector('.diosa-landing');
  if (!root) return;

  /* ============================================================
     1. GALERÍA (hero + thumbs)
     ============================================================ */
  var GSRC = Array.isArray(window.DIOSA_GAL) ? window.DIOSA_GAL : [];
  var gi = 0;

  function paint() {
    var img = document.getElementById('gmain-img');
    if (img && GSRC[gi]) {
      img.style.display = '';
      img.src = GSRC[gi];
      img.style.objectFit = (gi === 0) ? 'cover' : 'contain';
    }
    root.querySelectorAll('.thumb').forEach(function (t, i) {
      t.classList.toggle('active', i === gi);
    });
    var act = root.querySelectorAll('.thumb-w')[gi];
    if (act && act.scrollIntoView) act.scrollIntoView({ inline: 'center', block: 'nearest' });
  }
  window.pick = function (i) { gi = i; paint(); };
  window.gnav = function (d) { gi = (gi + d + GSRC.length) % GSRC.length; paint(); };

  /* ============================================================
     2. Releasit COD — variante + cantidad en el DOM, click botón nativo
     ============================================================ */
  var RELEASIT_SELECTORS = [
    '#rsi_buy_now_button',
    '.rsi_buy_now_button',
    '._rsi-buy-now-button',
    '._rsi-buy-now-button-app-block-hook button',
    '._rsi-buy-now-button-app-block-hook a',
    '.rsi-btn-skel'
  ];

  function findReleasitButton() {
    for (var i = 0; i < RELEASIT_SELECTORS.length; i++) {
      var el = document.querySelector(RELEASIT_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function setVariantOnAllForms(variantId, qty) {
    if (!variantId) return;
    var q = parseInt(qty, 10);
    if (!q || q < 1) q = 1;
    document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
      input.value = variantId;
    });
    document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
      input.value = variantId;
    });
    // Releasit lee la cantidad de input[name="quantity"] al abrir el modal
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.value = String(q);
      input.setAttribute('value', String(q));
    });
    if (window.productData) { window.productData.quantity = q; }
    if (window.productData && Array.isArray(window.productData.variants)) {
      var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
      if (v) {
        window.productData.selected_or_first_available_variant = v;
        window.productData.selected_variant = v;
        try {
          document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
          document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
        } catch (e) {}
      }
    }
  }

  function clickNativeReleasit() {
    var rb = findReleasitButton();
    if (rb) { rb.click(); return; }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var b = findReleasitButton();
      if (b) { clearInterval(poll); b.click(); return; }
      if (attempts > 30) {
        clearInterval(poll);
        // último recurso: la API abre el modal con la variante que Releasit
        // cacheó al init, así que solo se usa si no apareció el botón nativo.
        if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
          try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
        }
      }
    }, 100);
  }

  /* ============================================================
     3. Estado de compra: combo (cantidad) + color + talla
     ============================================================ */
  var VARIANTS = Array.isArray(window.DIOSA_VARIANTS) ? window.DIOSA_VARIANTS : [];
  var elColor = document.getElementById('ds-color');
  var elTalla = document.getElementById('ds-talla');
  var elSold = document.getElementById('ds-soldout');
  var elAtc = document.getElementById('atc-price');
  var elSticky = document.getElementById('sticky-price');

  var selColor = elColor ? elColor.value : null;
  var selTalla = elTalla ? elTalla.value : null;
  var selQty = 2;               // arranca en el combo más vendido (2 unidades)
  var selPrice = '149.900';

  function findVar(color, talla) {
    return VARIANTS.find(function (v) { return v.color === color && v.talla === talla; });
  }
  function currentVariant() { return findVar(selColor, selTalla); }

  function refresh() {
    var v = currentVariant();
    if (v) {
      setVariantOnAllForms(v.id, selQty);
      if (elSold) elSold.style.display = v.available ? 'none' : 'block';
    } else if (elSold) {
      elSold.style.display = 'block';
    }
    if (elAtc) elAtc.textContent = '$' + selPrice;
    if (elSticky) elSticky.textContent = '$' + selPrice + ' · CONTRA ENTREGA';
  }

  window.selBundle = function (el) {
    root.querySelectorAll('.buybox .bundle').forEach(function (b) { b.classList.remove('sel'); });
    el.classList.add('sel');
    selQty = parseInt(el.getAttribute('data-qty'), 10) || 1;
    selPrice = el.getAttribute('data-price') || selPrice;
    refresh();
  };

  if (elColor) elColor.addEventListener('change', function () { selColor = elColor.value; refresh(); });
  if (elTalla) elTalla.addEventListener('change', function () { selTalla = elTalla.value; refresh(); });

  window.diosaTriggerCOD = function () {
    var v = currentVariant();
    if (!v) { alert('Elige color y talla.'); return; }
    if (!v.available) {
      if (elSold) elSold.style.display = 'block';
      return;
    }
    setVariantOnAllForms(v.id, selQty);
    setTimeout(clickNativeReleasit, 50);
  };

  /* todos los CTA de compra abren el modal COD con la selección actual */
  root.querySelectorAll('.js-cod').forEach(function (btn) {
    btn.addEventListener('click', function () { window.diosaTriggerCOD(); });
  });

  refresh();
  paint();

  /* ============================================================
     4. Barra sticky
     ============================================================ */
  var buy = document.getElementById('buy');
  var sticky = document.getElementById('sticky');
  if (buy && sticky) {
    window.addEventListener('scroll', function () {
      var r = buy.getBoundingClientRect();
      if (r.bottom < 0 || window.scrollY > 900) { sticky.classList.add('show'); }
      else { sticky.classList.remove('show'); }
    });
  }

  /* ============================================================
     5. Rotador de citas de prensa
     ============================================================ */
  var pq = [
    '“Confía en las reseñas, este body de verdad funciona.”',
    '“Se agotó 11 veces en los últimos 7 meses.”',
    '“Ya ayudó a +23.000 mujeres a definir su silueta.”',
    '“El truco de las creadoras para que la ropa caiga perfecta.”'
  ];
  var pidx = 0;
  var pquote = document.getElementById('pquote');
  if (pquote) {
    setInterval(function () {
      pidx = (pidx + 1) % pq.length;
      pquote.textContent = pq[pidx];
      root.querySelectorAll('.press .dots i').forEach(function (d, i) { d.classList.toggle('on', i === pidx); });
    }, 3200);
  }

  /* ============================================================
     6. Contadores animados
     ============================================================ */
  function fmtNum(v, dec, thousands) {
    var s = dec > 0 ? v.toFixed(dec).replace('.', ',') : Math.round(v).toString();
    if (thousands) {
      var p = s.split(',');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      s = p.join(',');
    }
    return s;
  }
  function animateCup(el) {
    var target = parseFloat(el.getAttribute('data-target'));
    var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
    var thousands = el.getAttribute('data-thousands') === '1';
    var pre = el.getAttribute('data-prefix') || '', suf = el.getAttribute('data-suffix') || '';
    var ring = el.closest('.ring'), fill = ring ? parseFloat(ring.getAttribute('data-fill')) : null;
    var dur = 1500, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1), e = 1 - Math.pow(1 - p, 3);
      el.textContent = pre + fmtNum(target * e, dec, thousands) + suf;
      if (ring && fill != null) ring.style.background = 'conic-gradient(var(--teal) ' + (fill * e) + '%, #dfeaec 0)';
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  if ('IntersectionObserver' in window) {
    var cupObs = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting && !en.target.dataset.done) {
          en.target.dataset.done = '1';
          animateCup(en.target);
          cupObs.unobserve(en.target);
        }
      });
    }, { threshold: .5 });
    root.querySelectorAll('.cup').forEach(function (c) { cupObs.observe(c); });
  } else {
    root.querySelectorAll('.cup').forEach(animateCup);
  }

  /* ============================================================
     7. Escribir reseña (demo local, no persiste)
     ============================================================ */
  window.openReview = function () {
    var name = prompt('Tu nombre:');
    if (!name) return;
    var txt = prompt('Tu reseña:');
    if (!txt) return;
    var feed = document.getElementById('fbfeed');
    if (!feed) return;
    var c = document.createElement('div');
    c.className = 'fbcard';
    var top = document.createElement('div');
    top.className = 'fbtop';
    top.innerHTML = '<div class="av slot"></div><div><b></b> <span class="fb-verif">✓</span><div class="stars">★★★★★</div></div>';
    top.querySelector('b').textContent = name;
    var p = document.createElement('p');
    p.textContent = txt;
    var react = document.createElement('div');
    react.className = 'fbreact';
    react.textContent = '👍 0 · 💬 0 · Me encanta';
    c.appendChild(top); c.appendChild(p); c.appendChild(react);
    feed.insertBefore(c, feed.firstChild);
  };
})();
